module.exports = __webpack_public_path__ + "static/other/lab_diagnosis_analyze_blood.87d7ed4e.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/labDiagnosisGame/lab_diagnosis_analyze_blood.json
// module id = 866
// module chunks = 0